// extracted by mini-css-extract-plugin
module.exports = {"grid":"AvailableLoadsGrid_grid__XFcEY","gridItem":"AvailableLoadsGrid_gridItem__cQaVb","nudgeSlot":"AvailableLoadsGrid_nudgeSlot__crVOo"};